import * as React from "react";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import useMediaQuery from "@mui/material/useMediaQuery";
import { useTheme } from "@mui/material/styles";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import { CircularProgress, Stack } from "@mui/material";
import ErrorIcon from "@mui/icons-material/Error";

export default function ResetEmailUnverifiedPopup(props) {
  const {
    open,
    sendItem,
    handleClose,
    title,
    handleInformationPopup,
    generateButtonLoading,
    setGenerateButtonLoading,
  } = props;
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down("md"));

  return (
    <>
      <Dialog
        className="user-filter-popup manage-user-filter"
        sx={{ width: "100%" }}
        fullScreen={fullScreen}
        open={open}
        onClose={handleClose}
        aria-labelledby="responsive-dialog-title"
      >
        <Stack
          direction="row"
          spacing={0.5}
          alignItems="center"
          sx={{ p: "25px 25px 10px 25px" }}
        >
          <ErrorIcon
            fontSize="24px"
            style={{ color: "#007FFF", fontSize: "24px" }}
          />
          <Typography className="warning-title">Warning</Typography>
        </Stack>
        <Box sx={{ p: "0px 25px 0px 25px" }}>
          <p className="label">
            This email address has not been confirmed by the user. Only continue
            if you are certain this is the correct email address for this user.
          </p>
        </Box>
        <DialogActions
          sx={{ justifyContent: "flex-start", p: "20px 25px", pt: "21px" }}
        >
          <Button
            className={
              generateButtonLoading ? "disable-filter-btn" : "filter-btn"
            }
            onClick={() => handleInformationPopup()}
            disabled={generateButtonLoading}
          >
            {generateButtonLoading && (
              <CircularProgress
                color={"inherit"}
                size={10}
                sx={{ marginRight: "3px" }}
              />
            )}
            Continue
          </Button>

          <Button className="cancel-btn" onClick={handleClose}>
            Cancel
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}
